<template>
    <v-container>
        <v-row>
            <v-col
                v-for="(item, i) in menuItems"
                :key="i"
                cols="12"
                sm="6"
                md="4"               
            >
                <v-card
                    class="mod-card rounded-xl"
                    elevation="0"
                    @click="display(item.option)"
                    max-width="300"
                >
                    <v-card-text class="mod-card__body">
                        <div class="mod-card__icon mb-3" :style="{ background: item.bg }">
                            <v-icon :color="item.color" size="23">{{ item.icon }}</v-icon>
                        </div>
                        <p class="mod-card__title">{{ item.title }}</p>
                        <p class="mod-card__sub">{{ item.subtitle }}</p>
                    </v-card-text>
                    <div class="mod-card__accent" :style="{ background: item.color }" />
                </v-card>
            </v-col>    
        </v-row>
    </v-container>    
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
    name: 'MainMenu',
    created(){
        this.initialization();
    },
    data: () => ({
        menuItems: [
            {
                icon:  'mdi-pencil',
                title: 'Enter Marks ',
                subtitle: 'Subject Teachers',
                src: require("../assets/icons/enter-marks.png"),
                option: 'enter-marks',
                display: false,
                color: '#1565C0',
                bg: '#E3F2FD',
            },
            {
                icon:  'mdi-calendar-edit',
                title: 'Edit/View Term Reports ',
                subtitle: 'Form Teachers',
                src: require('../assets/icons/term-reports.png'),
                option: 'term-reports',
                display: false,
                color: '#6A1B9A',
                bg: '#F3E5F5',
            },
            {
                icon:  'mdi-printer',
                title: 'Print/View Reports',
                subtitle: 'Report Cards, Mark Sheets, etc.',
                src: require('../assets/icons/print-view-reports.png'),
                option: 'print-view-reports',
                display: false,
                color: '#00695C',
                bg: '#E0F2F1',
            },
            {
                icon:  'mdi-account-group',
                title: 'Employees',
                subtitle: 'Add / Edit Teachers, Timetables',
                src: require('../assets/icons/teacher.png'),
                option: 'employees',
                display: false,
                color: '#BF360C',
                bg:'#FBE9E7',
            },
            {
                icon:  'mdi-clipboard-list',
                title: 'Student Subjects',
                subtitle: 'Form 4-6 Student Subjects ',
                src: require('../assets/icons/subject-assignment.png'),
                option: 'student-subjects',
                display: false,
                color: '#2E7D32',
                bg:  '#E8F5E9',
            },
            {
                icon:  'mdi-account-school',
                title: 'Students',
                subtitle: 'View/Edit Student Records',
                src: require('../assets/icons/edit-view-students.png'),
                option: 'edit-view-students',
                display: false,
                color: '#283593',
                bg:'#E8EAF6',
            },
            {
                icon:  'mdi-lock-reset',
                title: 'Reset Password',
                subtitle: 'Reset Employee Passwords',
                src: require('../assets/icons/reset-password.png'),
                option: 'reset-password',
                display: false,
                color: '#B71C1C',
                bg: '#FFEBEE',
            },
            {
                icon:  'mdi-cog',
                title: 'Settings',
                subtitle: 'System Configuration',
                src: require('../assets/icons/settings.png'),
                option: 'settings',
                display: false,
                color: '#37474F',
                bg: '#ECEFF1',
            }, 
        ],
        menu: '',  
    }),
    computed: {
        ...mapGetters({
            user: 'auth/getUser',
            primaryColor: 'app/getPrimaryColor',
            colorDarken: 'app/getColorDarken',
            getMarkSheetLoading: 'termReports/getMarkSheetLoading',
            getTermReportsOverlay: 'termReports/getOverlay',            
            id: 'auth/getEmployeeId',
            userPermissions: 'auth/getPermissions',
        }),
        iconColor(){
            return this.primaryColor + ' ' + this.colorDarken;
        },
        titleClass(){
            return 'subtitle-1 font-weight-light font-italic ' + this.primaryColor + '--text text--' + this.colorDarken;
        },
        cardTitleClass(){
            return 'py-2 pl-8 caption white--text font-weight-light text-uppercase ' + this.primaryColor + ' ' + this.colorDarken;
        },
        fontClass(){
            return 'font-weight-normal text-uppercase ' + this.primaryColor + '--text text--' + this.colorDarken;
        }
    },
    watch: {
        //
    },
    methods: {
        ...mapMutations({
            mainMenu: 'mainMenu/setMainMenu',
            markSheet: 'mainMenu/setMarkSheet',
            termReports: 'mainMenu/setTermReports',
            employees: 'mainMenu/setEmployees',
            reports: 'mainMenu/setReports',
            studentSubjects: 'mainMenu/setStudentSubjects',
            editViewStudents: 'mainMenu/setEditViewStudents',
            resetPassword: 'mainMenu/setResetPassword',
            welcomeMessage: 'mainMenu/setWelcomeMessage',
            markSheetOverlay: 'markSheet/setMarkSheetOverlay',            
            markSheetLoading: 'markSheet/setMarkSheetLoading',
            setEditTermMark: 'auth/setEditTermMark',
            settings: 'mainMenu/setSettings', 
            setAdmin: 'auth/setAdmin',                     
        }),               
       
        display(option){
            //console.log(option);
            this.welcomeMessage(false);
            switch(option){
                case 'enter-marks':
                    this.showMenu('enter-marks');
                    break;
                case 'term-reports':
                    this.showMenu('term-reports');
                    break;
                case 'employees':
                    console.log('timetable clicked');
                    this.showMenu('employees');
                    break
                case 'print-view-reports':
                    console.log('print view reports');
                    this.showMenu('print-view-reports');
                    break               
                case 'student-subjects':
                    console.log('student subjects');
                    this.showMenu('student-subjects');
                    break               
                case 'edit-view-students':
                    console.log('edit view students');
                    this.showMenu('edit-view-students');
                    break               
                case 'reset-password':
                    console.log('reset password');
                    this.showMenu('reset-password');
                    break               
                case 'settings':                    
                    this.showMenu('settings');
                    break               
            }
        },

        initialization(){
            const userPermissions = JSON.parse(sessionStorage.getItem('permissions'));
            const user = JSON.parse(this.user);

            if(user.employee_id !== 'Admin'){
                userPermissions.forEach(permission => {
                    if(permission.permission_id < 9){
                        this.menuItems[permission.permission_id - 1].display = true;
                    }
                    else if(permission.permission_id == 9){
                        this.setEditTermMark(true);
                        this.setAdmin(true);
                        sessionStorage.setItem('admin', true);
                    }
                                  
                })
                return;
            }

            this.menuItems.forEach(item => {
                item.display = true;
            })
        },

        showMenu(menu){            
            this.mainMenu(false);
            this.markSheet(false);
            this.termReports(false);
            this.employees(false);
            this.reports(false);
            this.studentSubjects(false);
            this.editViewStudents(false);
            this.resetPassword(false);
            this.settings(false);            
            if(menu == 'enter-marks') this.markSheet(true);
            if(menu == 'term-reports') this.termReports(true);
            if(menu == 'employees') this.employees(true);
            if(menu == 'print-view-reports') this.reports(true);
            if(menu == 'student-subjects') this.studentSubjects(true);
            if(menu == 'edit-view-students') this.editViewStudents(true);
            if(menu == 'reset-password') this.resetPassword(true);
            if(menu == 'settings') this.settings(true);
        }

    }
}
</script>

<style scoped>
 .v-card__title{
    word-break: break-word;
    text-align: center;
 }

 /* ── Module Card ─────────────────────────────────────────────── */
.mod-card {
  border: 1px solid rgba(0, 0, 0, 0.07) !important;
  background: white !important;
  cursor: pointer;
  overflow: hidden !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
 
.mod-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 28px rgba(26, 35, 126, 0.13) !important;
}
 
.mod-card__body {
  padding: 18px 18px 14px !important;
}
 
.mod-card__icon {
  width: 50px;
  height: 50px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
 
.mod-card__title {
  margin: 0 0 3px;
  font-weight: 600;
  font-size: 1rem;
  color: #1A1A2E;
  line-height: 1.35;
}
 
.mod-card__sub {
  margin: 0;
  font-size: 11.5px;
  color: #9E9E9E;
  line-height: 1.4;
}
 
.mod-card__accent {
  height: 3px;
  opacity: 0.75;
}
</style>